import {
  AlarmOutlined,
  ArrowBack,
  East,
  LockOpen,
  MailOutline,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import PasswordStrengthBar from "react-password-strength-bar";
import apiServices from "../../services/RequestHandler";
import { strings } from "../../Store/Localization";
import CustomButton from "../../UiComponent/CustomButton";
import InputField from "../../UiComponent/TextFeild";
import Toast from "../../UiComponent/Toast/Toast";
import { defaultLabelColors } from "../../utils/constants";

function ForgotPassword(props: any) {
  const [otp, setOtp] = useState("");
  const [seconds, setSeconds] = useState<number>(60);
    const [isActive, setIsActive] = useState<boolean>(false);
  // const selector = useSelector((state: RootState) => state.mainApp);
  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      showOtpFeild: false,
      showResetpassword: false,
      viewPassword: false,
      viewConfirmPassword: false,
    }
  );

  // const strengthMessages = [
  //   // selector.lang === "fr" ? "Too Faible " : "too short",
  //   selector.lang === "fr" ? "Faible " : "Weak",
  //   selector.lang === "fr" ? "Moyen " : "Okay ",
  //   selector.lang === "fr" ? "Bon " : "Good ",
  //   selector.lang === "fr" ? "Fort" : "Strong",
  // ];

  const onInputChange = (e: any) => {
    try {
      const { value, name } = e.target;
      if (value[0] === " ") {
        return;
      }

      setState({
        [name]: value,
      });
    } catch (error) {}
  };

  let regEmail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const handleForgotPassword = async () => {
    try {
      if (!state?.username) {
        Toast.Error("Votre e-mail n'est pas valide");
        return;
      }
      if (!regEmail.test(state?.username)) {
        Toast.Error("Votre e-mail n'est pas valide ");
        setState({ disableSignUpBtn: false });
        return;
      }
      let obj = {
        username: state?.username,
      };
      let resp = await apiServices.postFromApi("c2c/forgot-password", obj, "");

      if (resp?.status === 201 || resp?.status === 200) {
        setState({ showOtpFeild: true, disableEmail: true });
        startTimer();

        return;
      } else {
        Toast.Error(
          resp?.error ??
            resp?.error?.error ??
            resp?.isEmail ??
            resp?.isNotEmpty ??
            "Something went wrong. Please wait a short while and try again. If problem persists then contact to support team."
        );
      }
    } catch (error) {}
  };

  const handleVerifyOtp = async () => {
    try {
      if (!otp) {
        Toast.Error("OTP ne peut pas être vide");
        return;
      }
      let obj = {
        username: state?.username,
        otp,
      };
      let resp = await apiServices.postFromApi(
        "c2c/validate-reset-code",
        obj,
        ""
      );

      if (resp?.status === 201 || resp?.status === 200) {
        Toast.showSuccess(resp?.message);
        setState({
          showOtpFeild: false,
          disableEmail: false,
          showResetpassword: true,
        });
        return;
      } else {
        Toast.Error(
          resp?.error ??
            resp?.error?.error ??
            resp?.isEmail ??
            resp?.isNotEmpty ??
            "Something went wrong. Please wait a short while and try again. If problem persists then contact to support team."
        );
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const startTimer = () => {
    setSeconds(60); // Reset to 30 seconds
    setIsActive(true);
  };
   useEffect(() => {
      let timerId: NodeJS.Timeout;
      if (isActive && seconds > 0) {
        timerId = setInterval(() => {
          setSeconds((prevSeconds) => prevSeconds - 1);
        }, 1000);
      } else if (seconds === 0) {
        setIsActive(false);
        setOtp("");
      }
      return () => clearInterval(timerId);
    }, [isActive, seconds]);

  const resetPassword = async () => {
    try {
      try {
        if (!state?.password) {
          Toast.Error("le mot de passe ne doit pas être vide");
          return;
        }
        if (!state?.password_confirm) {
          Toast.Error("confirmer que le mot de passe ne doit pas être vide");
          return;
        }

        if (state?.password !== state?.password_confirm) {
          Toast.Error("Le mot de passe doit être le même");
          return;
        }
        let obj = {
          username: state?.username,
          password: state?.password,
          password_confirm: state?.password_confirm,
          otp: otp,
        };
        let resp = await apiServices.postFromApi("c2c/reset-password", obj, "");

        if (resp?.status === 201 || resp?.status === 200) {
          Toast.showSuccess(resp?.message);
          setState({
            showOtpFeild: false,
            disableEmail: false,
            showResetPassword: false,
          });
          //   navigate("/login")
          window.location.reload();
          return;
        } else {
          Toast.Error(
            resp?.error ??
              resp?.error?.error ??
              resp?.isEmail ??
              resp?.isNotEmpty ??
              resp?.message ??
              "Something went wrong. Please wait a short while and try again. If problem persists then contact to support team."
          );
        }
      } catch (error) {
        console.log("error", error);
      }
    } catch (error) {}
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        style={{ padding: "50px" }}
        className="display-flex"
      >
        <Grid container spacing={2}>
          <Grid
            xs={12}
            item
            className="display-flex"
            style={{ display: "flex" }}
          >
            <div
              style={{
                borderRadius: 100,
                padding: "10px",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 111111,
                background: defaultLabelColors.main_blue,
              }}
              onClick={() => {
                if (props.handleBack) {
                  props.handleBack();
                }
              }}
            >
              <ArrowBack style={{ cursor: "pointer", color: "#fff" }} />
            </div>

            {state?.showResetpassword ? (
              <>
                <Grid
                  container
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Grid
                    xs={12}
                    item
                    className="display-flex"
                    style={{ flexDirection: "column" }}
                  >
                    <p
                      className="heading-one"
                      style={{
                        fontFamily: "Raleway-Italic",
                        color: defaultLabelColors.main_blue,
                        textAlign: "center",
                      }}
                    >
                      {/* {"Reset Password"} */}
                      Nouveau mot de passe
                    </p>
                    <p
                      className="paragraph-text"
                      style={{
                        marginTop: "-30px",
                        textAlign: "center",
                        fontFamily: "Raleway-Italic",
                        fontWeight: "500",
                        width: "500px",
                      }}
                    ></p>
                  </Grid>

                  <Grid
                    xs={12}
                    item
                    className="display-flex"
                    style={{ textAlign: "center", flexDirection: "column" }}
                  >
                    <InputField
                      input_type={
                        state?.viewPassword === false ? "password" : "text"
                      }
                      onchange={onInputChange}
                      startIcon={<LockOpen />}
                      placeHolder={"Mot de passe "}
                      input_value={state?.password}
                      input_name={"password"}
                      input_style={{
                        background: "#fff",
                        width: "500px",
                        borderRadius: "16px",
                        border: "none",
                      }}
                      endIicon={
                        state?.viewPassword ? (
                          <Visibility
                            onClick={() => {
                              setState({ viewPassword: !state?.viewPassword });
                            }}
                            style={{ color: "gray", cursor: "pointer" }}
                          />
                        ) : (
                          <VisibilityOff
                            onClick={() => {
                              setState({ viewPassword: !state?.viewPassword });
                            }}
                            style={{ color: "gray", cursor: "pointer" }}
                          />
                        )
                      }
                    />
                    <PasswordStrengthBar
                      password={state?.password}
                      style={{ width: "500px" }}
                      minLength={6}
                      scoreWords={[
                        "Faible",
                        "Faible",
                        "Moyen",
                        "Moyen",
                        "Fort",
                      ]}
                      className="custom-strength-bar"
                      shortScoreWord={"Faible"}
                    />
                  </Grid>

                  <Grid xs={12} item style={{ textAlign: "center" }}>
                    <InputField
                      input_type={
                        state?.viewConfirmPassword === false
                          ? "password"
                          : "text"
                      }
                      onchange={onInputChange}
                      startIcon={<LockOpen />}
                      placeHolder={"Confirmation du mot de passe"}
                      input_value={state?.password_confirm}
                      input_name={"password_confirm"}
                      input_style={{
                        background: "#fff",
                        width: "500px",
                        borderRadius: "16px",
                        border: "none",
                      }}
                      endIicon={
                        state?.viewConfirmPassword ? (
                          <Visibility
                            onClick={() => {
                              setState({
                                viewConfirmPassword:
                                  !state?.viewConfirmPassword,
                              });
                            }}
                            style={{ color: "gray", cursor: "pointer" }}
                          />
                        ) : (
                          <VisibilityOff
                            onClick={() => {
                              setState({
                                viewConfirmPassword:
                                  !state?.viewConfirmPassword,
                              });
                            }}
                            style={{ color: "gray", cursor: "pointer" }}
                          />
                        )
                      }
                    />
                  </Grid>

                  <Grid
                    xs={12}
                    item
                    className="display-flex"
                    sx={{ paddingTop: 2 }}
                  >
                    <CustomButton
                      style={{
                        width: "260px",
                      }}
                      onClick={resetPassword}
                      classesNames={"contained_button_two"}
                      value={
                        <React.Fragment>
                          <div
                            className="display-flex"
                            style={{
                              columnGap: "10px",
                              padding: "8px 0px 8px 0px",
                              fontSize: "16px",
                            }}
                          >
                            ME CONNECTER
                            <East
                              style={{
                                color: defaultLabelColors.main_blue,
                                background: "#f9d9b6",
                                borderRadius: 100,
                                padding: 4,
                                fontSize: 18,
                              }}
                            />
                          </div>
                        </React.Fragment>
                      }
                    />
                  </Grid>
                </Grid>
              </>
            ) : (
              <Grid container spacing={2}>
                <Grid
                  xs={12}
                  item
                  className="display-flex"
                  style={{ flexDirection: "column" }}
                >
                  <h1
                    className="heading-one"
                    style={{
                      fontFamily: "Raleway-Italic",
                      color: defaultLabelColors.main_blue,
                      textAlign: "center",
                    }}
                  >
                    {strings.Forgot_password_title ?? "Forgot Password"}
                  </h1>
                  <p
                    className="paragraph-text"
                    style={{
                      marginTop: "-30px",
                      textAlign: "center",
                      fontFamily: "Raleway-Italic",
                      fontWeight: "500",
                      width: "500px",
                    }}
                  >
                    Mot de passe oublié? Aucun problème! <br /> Entrez
                    simplement votre adresse e-mail pour la réinitialiser en
                    quelques étapes
                  </p>
                </Grid>

                <Grid
                  xs={12}
                  item
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <InputField
                    isDisable={state?.disableEmail}
                    placeHolder={"Adresse e-mail"}
                    onchange={onInputChange}
                    startIcon={<MailOutline />}
                    input_value={state?.username}
                    input_name={"username"}
                    input_style={{
                      background: "#fff",
                      borderRadius: 100,
                      maxWidth: "400px",
                    }}
                  />
                  {state?.showOtpFeild && (
                    <div className="display-flex" style={{ gap: "20px" }}>
                      <p style={{ fontFamily: "Raleway-Variable",display:'none' }}>
                        Vous n’avez pas reçu le code ?
                      </p>
                      {seconds < 1 ? (
                        <p
                           onClick={handleForgotPassword}
                          style={{
                            fontFamily: "Raleway-Semi-Bold",
                            color: defaultLabelColors.main_orange,
                            cursor: "pointer",
                            margin:0
                          }}
                        >
                          Renvoyez le code
                        </p>
                      ) : (
                        <p
                          style={{
                            fontFamily: "Raleway-Variable",
                            opacity: "60%",
                          }}
                        >
                          Renvoyez le code
                        </p>
                      )}
                      {seconds < 1 ? (
                        <div></div>
                      ) : (
                        <p
                          style={{
                            fontFamily: "Raleway-Extra-Bold",
                          }}
                          className="display-flex"
                        >
                          <AlarmOutlined />
                          {seconds} s
                        </p>
                      )}
                    </div>
                  )}
                </Grid>

                {!state?.showOtpFeild ? (
                  <Grid xs={12} item className="display-flex">
                    <CustomButton
                      style={{
                        width: "260px",
                      }}
                      onClick={handleForgotPassword}
                      classesNames={"contained_button_two"}
                      value={
                        <React.Fragment>
                          <div
                            className="display-flex"
                            style={{
                              columnGap: "10px",
                              padding: "8px 0px 8px 0px",
                              fontSize: "16px",
                            }}
                          >
                            Suivant
                            <East
                              style={{
                                color: defaultLabelColors.main_blue,
                                background: "#f9d9b6",
                                borderRadius: 100,
                                padding: 4,
                                fontSize: 18,
                              }}
                            />
                          </div>
                        </React.Fragment>
                      }
                    />
                  </Grid>
                ) : null}

                {state?.showOtpFeild ? (
                  <>
                    <Grid
                      xs={12}
                      item
                      style={{
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <OTPInput
                        inputStyle={{
                          fontFamily: "Raleway-Variable",
                          fontSize: "32px",
                          fontWeight: "900",
                          color: "#000",
                          border: "none",
                          background: "#F4F3F6",
                          borderRadius: "12px",
                          padding: "20px",
                        }}
                        inputType="number"
                        value={otp}
                        onChange={setOtp}
                        numInputs={4}
                        renderSeparator={
                          <span style={{ padding: "15px" }}></span>
                        }
                        renderInput={(props) => <input {...props} />}
                      />

                      <p
                        className="paragraph-text"
                        style={{
                          // marginTop: "-30px",
                          textAlign: "center",
                          fontFamily: "Raleway-Italic",
                          fontWeight: "500",
                          fontSize: "16px",
                          width: "500px",
                        }}
                      >
                        Veuillez mentionner le code de confirmation que vous
                        avez reçu par mail.
                      </p>
                    </Grid>

                    <Grid xs={12} item className="display-flex">
                      <CustomButton
                        style={{
                          width: "260px",
                        }}
                        onClick={handleVerifyOtp}
                        classesNames={"contained_button_two"}
                        value={
                          <React.Fragment>
                            <div
                              className="display-flex"
                              style={{
                                columnGap: "10px",
                                padding: "8px 0px 8px 0px",
                                fontSize: "16px",
                              }}
                            >
                              ME CONNECTER
                              <East
                                style={{
                                  color: defaultLabelColors.main_blue,
                                  background: "#f9d9b6",
                                  borderRadius: 100,
                                  padding: 4,
                                  fontSize: 18,
                                }}
                              />
                            </div>
                          </React.Fragment>
                        }
                      />
                    </Grid>
                  </>
                ) : null}
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default ForgotPassword;
